import React from 'react';

const WidgetSettingsEditorColumn = ({ children }) => (
	<div style={{ flex: 1, width: '100%', height: '100%', overflowY: 'auto' }}>
		{children}
	</div>
);

export default WidgetSettingsEditorColumn;
